import React from 'react';
import './ISBC.css';
import StickyVideoUp from '../../StickyVideoUp';
import Artboard1 from "../../../assests/Artboard 1.png"
import Artboard2 from "../../../assests/Artboard 2.png"
import Artboard3 from "../../../assests/Artboard 3.png"
import Artboard4 from "../../../assests/Artboard 4.png"
import Artboard5 from "../../../assests/Artboard 5.png"
import Artboard6 from "../../../assests/Artboard 6.png"
import Artboard7 from "../../../assests/Artboard 7.png"
import Artboard8 from "../../../assests/Artboard 8.png"
import Artboard9 from "../../../assests/Artboard 9.png"
import Artboard10 from "../../../assests/Artboard 10.png"
import Artboard11 from "../../../assests/Artboard 11.png"
import Artboard12 from "../../../assests/Artboard 12.png"
import Artboard13 from "../../../assests/Artboard 13.png"
import Artboard14 from "../../../assests/Artboard 14.png"

function ISBC() {
  const imagePaths = [
    Artboard1,
    Artboard2,
    Artboard3,
    Artboard4,
    Artboard5,
    Artboard6,
    Artboard7,
    Artboard8,
    Artboard9,
    Artboard10,
    Artboard11,
    Artboard12,
    Artboard13,
    Artboard14,
  ];

  return (
    <>
      <StickyVideoUp />
      <div className='IsbcpdfContainer'>
        {imagePaths.map((path, index) => (
          <div key={index} className='IsbcPdfImg'>
            <img className='images-isbc-pdf' src={path} alt='isbc' />
          </div>
        ))}
      </div>
    </>
  );
}

export default ISBC;

